import script from "./Permanent.vue?vue&type=script&setup=true&lang=js"
export * from "./Permanent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__